/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { AccommodationInvoiceRefundState } from '../state/AccommodationInvoiceRefundState'
import AccommodationInvoiceEvent from '../../event/AccommodationInvoiceEvent'

class AccommodationInvoiceRefundStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AccommodationInvoiceRefundState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AccommodationInvoiceEvent.clearRefund:
        return state.clear()
      case AccommodationInvoiceEvent.onEditRefund:
        return state.set(payload.name, payload.value)
      default:
        return state
    }
  }
}

export default new AccommodationInvoiceRefundStore()
